import Container from './container'

export default Container



// WEBPACK FOOTER //
// ./src/register-new/index.js